import usuario from './modules/usuario'
import parceiro from './modules/parceiro'
import notificacao from './modules/notificacao'

/* Vueex */
import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    usuario,
    parceiro,
    notificacao
  }
})




// WEBPACK FOOTER //
// ./src/vuex/store.js